import { createContext, ReactNode, useContext } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import Api from "./Api";
import { ErrorPage } from "../pages/ErrorPage";

export type ApiContextValue = {
  api: Api;
};
export const apiContext = createContext<ApiContextValue | null>(null);
export function useApiContext(): ApiContextValue {
  const ctx = useContext(apiContext);
  if (!ctx) throw new Error("useApiContext must be used within ApiProvider");
  return ctx;
}

type ApiProviderProps = { children: ReactNode };
export function ApiProvider(props: ApiProviderProps) {
  return <DomainRouter {...props} />;
}

function DomainRouter(props: ApiProviderProps) {
  return (
    <Routes>
      <Route path=":domain/*" element={<DomainInitializer {...props} />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

function DomainInitializer(props: ApiProviderProps) {
  const { domain } = useParams();
  if (!domain) {
    return <ErrorPage />;
  }

  return <ApiInitializer domain={domain} {...props} />;
}

function ApiInitializer({ domain, children }: ApiProviderProps & { domain: string }) {
  const api = new Api(domain);
  return <apiContext.Provider value={{ api }}>{children}</apiContext.Provider>;
}
